import React, { useEffect, useState } from "react";
import Search from "../../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Dropdown, Table, Tooltip } from "antd";
import svg27 from "../../../assets/svg/svg27.svg";
import BreadCrumb from "../../../layout/BreadCrumb";
import CardLoading from "../../../components/CardLoading";
import { Link, useNavigate } from "react-router-dom";
import svg15 from "../../../assets/svg/svg15.svg";
import svg12 from "../../../assets/svg/svg12.svg";
import svg29 from "../../../assets/svg/svg29.svg";
import {
  fetchCounties,
  fetchCrops,
  fetchData,
  fetchFundingMode,
  fetchIrrigationType,
  fetchMemberTypes,
  fetchWaterSources,
  fetchWtrAbstraction,
  fetchWtrApplMode,
  fetchWtrConvMeans,
} from "../../../features/fetch/fetchSlice";
import moment from "moment";
import { setActiveObj } from "../../../features/obj/objSlice";
import { formatText } from "../../../utils";

function SchemeTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const url = "sch/get_schemes";
  const urlAgency = "api/v2/agency/get";
  const urlFundingSrc = "sch/get_funding_source";
  const urlSchCard = "sch/get_dashboard";
  const urlPathway = "api/v2/irrigationPathway/get";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
    dataPathway: state.fetch.data[urlPathway] || [],
  }));

  const {user} =  useSelector((state)=>state.auth)

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        schName: e.target.value == "" ? null : e.target.value,
        schSchemeType: "PUBLIC",
        limit: null,
        start: 0,
      })
    );
  };
  const truncateText = (text, maxLength) => {
    if (text?.length > maxLength) {
      return text?.substring(0, maxLength - 3) + "...";
    }
    return text;
  };

  const handleEdit = async () => {
    await dispatch(setActiveObj({ key: "schemes", data: prodd }));
    await navigate("/scheme/public-scheme-add");
  };
  const handleAdd = async () => {
    await dispatch(setActiveObj({ key: "schemes", data: {} }));
    await navigate("/scheme/public-scheme-add");
  };
  const handleView = async () => {
    await dispatch(
      fetchData({
        url: urlSchCard,
        schId: prodd?.schId,
        limit: null,
        start: 0,
      })
    );
    await navigate("/scheme/public-scheme-view");
    await dispatch(setActiveObj({ key: "schemes", data: prodd }));
  };
  const handleViewName = async (item) => {
    await dispatch(
      fetchData({
        url: urlSchCard,
        schId: item?.schId,
        limit: null,
        start: 0,
      })
    );
    await navigate("/scheme/public-scheme-view");
    await dispatch(setActiveObj({ key: "schemes", data: item }));
  };

  const settingItems = [
    {
      key: "0",
      label: (
        <div onClick={handleView}>
          <Link className="flex actions-text gap-x-[.75rem]  ">
            <img src={svg15} alt="svg15" className="w-4 h-4" /> View
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },

    {
      key: "1",
      label: (
        <div onClick={handleEdit}>
          <Link className="flex actions-text gap-x-[.75rem] my-2">
            <img src={svg12} alt="svg12" className="w-4 h-4" /> Edit
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    // {
    //   key: "2",
    //   label: (
    //     <Link className="flex actions-text gap-x-[.75rem] my-2">
    //       <img src={svg13} alt="svg13" className="w-4 h-4" /> Delete
    //     </Link>
    //   ),
    // },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Scheme",
      render: (item) => {
        return (
          <div className="cursor-pointer" onClick={() => handleViewName(item)}>
            {item?.schName}
          </div>
        );
      },
      sorter: (a, b) => a.schName.localeCompare(b.schName),
    },
    {
      title: "County",
      dataIndex: "schCountyName",
      sorter: (a, b) => a.schCountyName.localeCompare(b.schCountyName),
    },

    {
      title: "Blocks",
      dataIndex: "schBlocks",
      sorter: (a, b) => a.schBlocks.localeCompare(b.schBlocks),
    },
    {
      title: "Crops Grown",
      dataIndex: "schCrops",

      render: (item) => {
        return (
          <>
            <Tooltip title={item}>
              <div className="">{truncateText(item, 35)}</div>
            </Tooltip>
          </>
        );
      },
      sorter: (a, b) => a.schCrops.localeCompare(b.schCrops),
    },
    {
      title: "Farmers",
      dataIndex: "schFarmersNumber",
      sorter: (a, b) => a.schFarmersNumber.localeCompare(b.schFarmersNumber),
    },
    {
      title: "Start Date",
      dataIndex: "schConstructionStartDate",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
      sorter: (a, b) =>
        moment(a.schConstructionStartDate).valueOf() -
        moment(b.schConstructionStartDate).valueOf(),
    },
    {
      title: "Irrigation Type",
      dataIndex: "schIrrigationType",
      sorter: (a, b) => a.schIrrigationType.localeCompare(b.schIrrigationType),
    },
    {
      title: "Status",
      dataIndex: "schStatus",
      render: (item) => {
        const colors = {
          ACTIVE: "#28A745",
          SILTED: "#3250FF",
          DORMANT: "#F44336",
        };

        return (
          <div
            className="text-[#FFF] inline-block rounded-[8px] px-[8px] py-[4px] w-auto !text-[12px]"
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchSchemeData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        schSchemeType: "PUBLIC",
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  async function fetchAgencyData() {
    await dispatch(
      fetchData({
        url: urlAgency,
        limit: null,
        start: 0,
      })
    );
  }

  async function fetchFundingSrcData() {
    await dispatch(
      fetchData({
        url: urlFundingSrc,
        limit: null,
        start: 0,
      })
    );
  }

  useEffect(() => {
    fetchSchemeData();
  }, []);

  useEffect(() => {
    dispatch(fetchCrops());
    dispatch(fetchWaterSources());
    dispatch(fetchIrrigationType());
    dispatch(fetchCounties());
    dispatch(fetchMemberTypes());

    dispatch(fetchFundingMode());
    dispatch(fetchWtrConvMeans());
    dispatch(fetchWtrApplMode());
    dispatch(fetchWtrAbstraction());
    fetchAgencyData();
    fetchFundingSrcData();
    dispatch(
      fetchData({
        url: urlPathway,
        limit: null,
        start: 0,
      })
    );
  }, []);
 

  if (loading && !searchInput) return <CardLoading />;
  return (
    <div className="min-h-[88vh] flex flex-col">
      <BreadCrumb
        breadcrumbs={[
          { title: "Schemes Overview", path: "/scheme/scheme-overview" },
         { title: `${user?.userInstitution === 'CIDU' ? user?.usrType + ' ' +  'Schemes' : 'Public Schemes'}` }
        ]}
      />
      <div className="flex flex-col w-full lg:px-[1.25rem] flex-1  white_card mt-[1.25rem]">
        <div className="flex items-center justify-between mt-[1.25rem]">
          <div className="form-add-h">{user?.userInstitution === 'CIDU' ? user?.usrType + ' ' + 'Schemes List' : 'Public Schemes List'}</div>
          <div className="w-[200px]">
            <button onClick={() => handleAdd()} className="cstm-btn-2">
              <img src={svg29} alt="svg29" />
              <span className="">Add Scheme</span>
            </button>
          </div>
        </div>
        <Divider />
        <div className="lg:w-[29.1875rem] w-auto mt-[1.25rem]">
          <Search
            searchInput={searchInput}
            handleSearch={handleSearch}
            text={"Search scheme..."}
          />
        </div>

        <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
          <section>
            <Table
              rowSelection={false}
              className="mt-[1.31rem] w-full"
              scroll={{
                x: 1200,
              }}
              rowKey={(record) => record?.schId}
              columns={columns}
              dataSource={data}
              loading={loading}
              pagination={{
                position: ["bottomRight"],
                current: pageIndex + 1,
                total: count,
                pageSize: pageSize,
                onChange: (page, size) => {
                  setPageIndex(page - 1);
                  setPageSize(size);
                  fetchSchemeData(page - 1, size);
                },
                showSizeChanger: false,
                hideOnSinglePage: true,
              }}
            />
          </section>
        </div>
      </div>
    </div>
  );
}

export default SchemeTable;
